import { Entity, Field } from "typegraph";

import { IOrganization } from "common/entities/organizationWrapper/OrganizationWrapper";
import CountResult from "./CountResult";

@Entity({one: "organization", many: "organizations"})
export default class Organization implements IOrganization {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field({entity: CountResult})
	public userCount: CountResult;

	@Field({entity: CountResult})
	public discussionCount: CountResult;

	@Field({entity: CountResult})
	public entryCount: CountResult;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/stats/entities/Organization.ts